<template>
  <div>
    <section
      class="presto-page-layout"
      ref="presto"
      v-html="pageContent"
    />
    <MountingPortal
      v-if="mounted"
      mount-to=".js-pro-map"
      name="source"
      append
    >
      <pro-plus-map />
    </MountingPortal>
  </div>
</template>

<script>
import ProPlusMap from './ProPlusMap'

export default {
  name: 'PageLayout',
  components: {
    ProPlusMap,
  },
  data() {
    return {
      mounted: false,
    }
  },
  computed: {
    pageContent() {
      return window.renaultRent.page.content
    },
  },
  mounted() {
    this.mounted = true
  },

};
</script>
